module.exports = __webpack_public_path__ + "56fcecdb68da612c5a5c2253f9af422f.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/head/TWS_gang.jpg
// module id = 765
// module chunks = 0